import React, { useReducer, useState } from "react"
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  
  LayersControl,
  GeoJSON,
} from "react-leaflet"
import "leaflet/dist/leaflet.css"
import L from "leaflet"
import { sanandajGeoJson } from "../../assets/seed/sanandaj-geo-json.js"
import { convertGeoJsonUTMtoWGS84 } from "./convertGeoJsonUTMtoWGS84"

import icon from "leaflet/dist/images/marker-icon.png"
import iconShadow from "leaflet/dist/images/marker-shadow.png"
import iconRetina from "leaflet/dist/images/marker-icon-2x.png"
import { SearchOutlined } from "@ant-design/icons"
import { Button, Checkbox, Input, Layout } from "antd"
import { NumericInput } from "components/Common/NumericInput"
import Locations from "components/Common/Locations"
import { MetaTags } from "react-meta-tags"
import { ProjectFiles } from "./ProjectFiles.js"
import { getCurrentUser } from "helpers/service_helper.js"

// Use a const for converted polygons
let DefaultIcon = L.icon({
  ...L.Icon.Default.prototype.options,
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: iconShadow,
})
L.Marker.prototype.options.icon = DefaultIcon

const GasProjectGis = ({ mainProps }) => {
  const {
    lstGasProjectsFullFilter,
    lstGasProjectsFullFilterTotal,
    loading,
    onGetGasProjectsFullFilter,
    onGetListProjectProcessEng,
    lstProjectProcessEng
  } = mainProps

  const [searchName, setSearchName] = useState("")
  const [pageSize, setPageSize] = useState(10)
  const [pageIndex, setPageIndex] = useState(1)
  const [dateCreated, setDateCreated] = useState("")
  const [filterCity, setFilterCity] = useState(false)

  const [mapRef, setMapRef] = useState(null)

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      fileNumber: null,
      searchValue: "",
      projectLevelEnum: 100,
      isStop: false,
      firstPlanFilter: false,
      isoFilter: false,
      serialNumber: "",
      isOk: false,
    }
  )

  const [sanandajGeoJsonWGS84, setSanandajGeoJsonWGS84] = useState(null)

  const handleInput = evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (evt.target.type === "checkbox") newValue = evt.target.checked

    setFormInput({ [name]: newValue })
  }

  const handleSearchGasProjectProcessEng = async val => {
    let searchQuery = {
      projectLevelEnum: 2,
      page: 1,
      pageSize: 20,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarDateDeliverEngineer: "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      landlordName: formInput.landlordName ? formInput.landlordName : "",
      executorName: formInput.exeName ? formInput.exeName : "",
    }

    //const params = serializeQuery(searchQuery)
    onGetListProjectProcessEng(searchQuery)
  }


  const handleSearchGasProject = async val => {
    setSanandajGeoJsonWGS84(null)
    setPageIndex(val === "search" ? 1 : pageIndex)
    setPageSize(val === "search" ? 10 : pageSize)
    let searchQuery = {
      ...formInput,
      page: val === "search" ? 1 : pageIndex,
      pageSize: val === "search" ? 10 : pageSize,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarRegisterDate: dateCreated?.persian ? dateCreated.persian : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,
      exeName: formInput?.exeName ? formInput.exeName : "",
      landLordName: formInput?.landLordName ? formInput.landLordName : "",
      isStop: formInput.isStop,
      firstPlanFilter: false,
      isoFilter: formInput.isoFilter,
      isFilterSubmitByAdmin: false,
      serialNumber: formInput.serialNumber,
    }
    // const params = serializeQuery(searchQuery)
    onGetGasProjectsFullFilter(searchQuery)
  }

  // Focus map on the first filtered project when searchName changes
  React.useEffect(() => {
    if (mapRef && lstGasProjectsFullFilter.length > 0) {
      if (filterCity && dataAddress?.cityId === 31) {
        setSanandajGeoJsonWGS84(
          
          convertGeoJsonUTMtoWGS84(sanandajGeoJson, lstGasProjectsFullFilter)
        )
      } else {
        setSanandajGeoJsonWGS84(null)
      }
      mapRef.setView(
        [
          lstGasProjectsFullFilter[0]?.lat.toFixed(4),
          lstGasProjectsFullFilter[0]?.lng.toFixed(4),
        ],
        15,
        { animate: true }
      )
    }
  }, [lstGasProjectsFullFilter, mapRef])


    React.useEffect(() => {
    if (mapRef && lstProjectProcessEng.length > 0) {
      if (filterCity && dataAddress?.cityId === 31) {
        setSanandajGeoJsonWGS84(
          
          convertGeoJsonUTMtoWGS84(sanandajGeoJson, lstProjectProcessEng)
        )
      } else {
        setSanandajGeoJsonWGS84(null)
      }
      mapRef.setView(
        [
          lstProjectProcessEng[0]?.lat.toFixed(4),
          lstProjectProcessEng[0]?.lng.toFixed(4),
        ],
        15,
        { animate: true }
      )
    }
  }, [lstProjectProcessEng, mapRef])

  // Call handleSearchGasProject on first load
  React.useEffect(() => {
    if(getCurrentUser().role === "Engineer"){
      handleSearchGasProjectProcessEng()
    }else{
    handleSearchGasProject()
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>GIS | واحد گاز</title>
      </MetaTags>

      <Layout>
        <div
          style={{
            background: "#fff",
            padding: 24,
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 16,
          }}
        >
          <Checkbox
            disabled={loading}
            style={{ marginRight: 8 }}
            onChange={e => setFilterCity(e.target.checked)}
          >
            فیلترشهر
          </Checkbox>
          {filterCity && (
            <Locations
              setDataAddress={setDataAddress}
              isAccessCity={true}
              inUseFilter={true}
              style={{ minWidth: 200 }}
            />
          )}
          <NumericInput
            style={{ width: 150 }}
            value={formInput.fileNumber}
            name="fileNumber"
            onChange={handleInput}
            placeholder="شماره پرونده"
            allowClear={true}
            disabled={loading}
          />
          <Input
            name="exeName"
            onChange={handleInput}
            placeholder="مجری"
            allowClear={true}
            style={{ width: 150 }}
            disabled={loading}
          />
          <Input
            name="landLordName"
            onChange={handleInput}
            placeholder="مالک"
            allowClear={true}
            style={{ width: 150 }}
            disabled={loading}
          />
          <Button
            loading={loading}
            type="primary"
            icon={<SearchOutlined />}
            onClick={() => handleSearchGasProject("search")}
            style={{ minWidth: 100 }}
          >
            جستجو
          </Button>
        </div>
        <div style={{ height: "80vh", width: "100%", minHeight: 400 }}>
          <MapContainer
            center={
              lstGasProjectsFullFilter.length > 0
                ? [
                    lstGasProjectsFullFilter[0].lat,
                    lstGasProjectsFullFilter[0].lng,
                  ]
                : [dataAddress.fullAddress.lat, dataAddress.fullAddress.lng]
            }
            zoom={9}
            style={{ height: "100%", width: "100%" }}
            whenCreated={setMapRef}
          >
            <LayersControl position="topright">
              <LayersControl.BaseLayer checked name="OpenStreetMap">
                <TileLayer
                  attribution='<a href="http://vahedgas.ir">GasUnit</a>'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="OpenTopoMap">
                <TileLayer
                  attribution='Map data: &copy; <a href="https://opentopomap.org">OpenTopoMap</a>'
                  url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="CartoDB Dark Matter">
                <TileLayer
                  attribution='&copy; <a href="https://carto.com/attributions">CARTO</a>'
                  url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="Satellite (Esri)">
                <TileLayer
                  attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                  url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                />
              </LayersControl.BaseLayer>
              {/* Always show Sanandaj polygons if filterCity is true and cityId is 31 */}
              {sanandajGeoJsonWGS84 &&
                lstGasProjectsFullFilter &&
                lstGasProjectsFullFilter.length > 0 && (
                  <GeoJSON
                    key={lstGasProjectsFullFilter.map(p => p.id).join("-")}
                    data={sanandajGeoJsonWGS84}
                    style={feature => ({
                      color: feature.properties.color || "red",
                      fillColor: feature.properties.color || "red",
                      fillOpacity: 0.3,
                    })}
                    onEachFeature={(feature, layer) => {
                      let props = feature.properties || {}
                      let popupContent = `<div style='direction:rtl;text-align:right;'>`
                      if (props.lat && props.lng) {
                        popupContent += `<div><strong>lat:</strong> ${props.lat}</div><div><strong>lng:</strong> ${props.lng}</div>`
                      }
                      if (
                        props.blockHasProject &&
                        props.projectList &&
                        props.projectList.length > 0
                      ) {
                        popupContent += `<div><strong>تعداد پروژه:</strong> ${props.projectList.length}</div>`
                        popupContent += `<div><strong>پروژه ها:</strong></div>`
                        props.projectList.forEach(p => {
                          popupContent += `<div><strong>شماره پرونده:</strong> ${p.fileNumber}</div>`
                          popupContent += `<div><strong>نام مالک:</strong> ${p.landLordName}</div>`
                          popupContent += `<div><strong>تاریخ ایجاد:</strong> ${p.solarRegisterDate}</div>`
                        })
                      }
                      layer.bindPopup(popupContent)
                    }}
                  />
                )}

              {lstGasProjectsFullFilter.map(project => {
                // Offset position by ~10 meters in a random direction
                // 1 deg lat ~ 111320m, 1 deg lng ~ 88000m (at 35 deg lat)
                const distanceMeters = 1000
                const angle = Math.random() * 2 * Math.PI // random direction
                const latOffset = (distanceMeters * Math.cos(angle)) / 111320
                const lngOffset = (distanceMeters * Math.sin(angle)) / 88000
                let newLat = project.lat + latOffset
                let newLng = project.lng + lngOffset

                // If only one project, use its coordinates directly
                if (lstGasProjectsFullFilter.length === 1) {
                  newLat = project.lat
                  newLng = project.lng
                }

                return (
                  <Marker key={project.id} position={[newLat, newLng]}>
                    <Popup minWidth={320}>
                      <div
                        style={{
                          minWidth: 270,
                          direction: "rtl",
                          textAlign: "right",
                          fontFamily: "Vazirmatn, Tahoma, Arial",
                          fontSize: 15,
                        }}
                      >
                        <div
                          style={{
                            background: "#f5f7fa",
                            borderRadius: 8,
                            padding: "12px 16px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            marginBottom: 8,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              color: "#2d8cf0",
                              fontWeight: 700,
                              fontSize: 17,
                              marginBottom: 6,
                            }}
                          >
                            <span style={{ marginLeft: 6 }}>شماره پرونده:</span>{" "}
                            {project.fileNumber}
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <span style={{ color: "#888", fontWeight: 500 }}>
                              نام مالک:
                            </span>{" "}
                            <span style={{ color: "#222", fontWeight: 600 }}>
                              {project.landLordName || project.landlordName}
                            </span>
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <span style={{ color: "#888", fontWeight: 500 }}>
                              تاریخ ایجاد:
                            </span>{" "}
                            <span style={{ color: "#222", fontWeight: 600 }}>
                              {project.solarRegisterDate}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            margin: "12px 0",
                            background: "#f0f4ff",
                            borderRadius: 6,
                            padding: 8,
                          }}
                        >
                          <ProjectFiles
                            rowData={{
                              id: project.id,
                              fileNumber: project.fileNumber,
                              // add more fields if needed
                            }}
                            mainProps={mainProps}
                          />
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                )
              })}


              {sanandajGeoJsonWGS84 &&
                lstGasProjectsFullFilter &&
                lstGasProjectsFullFilter.length > 0 && (
                  <GeoJSON
                    key={lstGasProjectsFullFilter.map(p => p.id).join("-")}
                    data={sanandajGeoJsonWGS84}
                    style={feature => ({
                      color: feature.properties.color || "red",
                      fillColor: feature.properties.color || "red",
                      fillOpacity: 0.3,
                    })}
                    onEachFeature={(feature, layer) => {
                      let props = feature.properties || {}
                      let popupContent = `<div style='direction:rtl;text-align:right;'>`
                      if (props.lat && props.lng) {
                        popupContent += `<div><strong>lat:</strong> ${props.lat}</div><div><strong>lng:</strong> ${props.lng}</div>`
                      }
                      if (
                        props.blockHasProject &&
                        props.projectList &&
                        props.projectList.length > 0
                      ) {
                        popupContent += `<div><strong>تعداد پروژه:</strong> ${props.projectList.length}</div>`
                        popupContent += `<div><strong>پروژه ها:</strong></div>`
                        props.projectList.forEach(p => {
                          popupContent += `<div><strong>شماره پرونده:</strong> ${p.fileNumber}</div>`
                          popupContent += `<div><strong>نام مالک:</strong> ${p.landLordName}</div>`
                          popupContent += `<div><strong>تاریخ ایجاد:</strong> ${p.solarRegisterDate}</div>`
                        })
                      }
                      layer.bindPopup(popupContent)
                    }}
                  />
                )}

              {lstProjectProcessEng.map(project => {
                // Offset position by ~10 meters in a random direction
                // 1 deg lat ~ 111320m, 1 deg lng ~ 88000m (at 35 deg lat)
                const distanceMeters = 1000
                const angle = Math.random() * 2 * Math.PI // random direction
                const latOffset = (distanceMeters * Math.cos(angle)) / 111320
                const lngOffset = (distanceMeters * Math.sin(angle)) / 88000
                let newLat = project.lat + latOffset
                let newLng = project.lng + lngOffset

                // If only one project, use its coordinates directly
                if (lstProjectProcessEng.length === 1) {
                  newLat = project.lat
                  newLng = project.lng
                }

                return (
                  <Marker key={project.id} position={[newLat, newLng]}>
                    <Popup minWidth={320}>
                      <div
                        style={{
                          minWidth: 270,
                          direction: "rtl",
                          textAlign: "right",
                          fontFamily: "Vazirmatn, Tahoma, Arial",
                          fontSize: 15,
                        }}
                      >
                        <div
                          style={{
                            background: "#f5f7fa",
                            borderRadius: 8,
                            padding: "12px 16px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                            marginBottom: 8,
                            border: "1px solid #e0e0e0",
                          }}
                        >
                          <div
                            style={{
                              color: "#2d8cf0",
                              fontWeight: 700,
                              fontSize: 17,
                              marginBottom: 6,
                            }}
                          >
                            <span style={{ marginLeft: 6 }}>شماره پرونده:</span>{" "}
                            {project.fileNumber}
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <span style={{ color: "#888", fontWeight: 500 }}>
                              نام مالک:
                            </span>{" "}
                            <span style={{ color: "#222", fontWeight: 600 }}>
                              {project.landLordName || project.landlordName}
                            </span>
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <span style={{ color: "#888", fontWeight: 500 }}>
                              تاریخ ایجاد:
                            </span>{" "}
                            <span style={{ color: "#222", fontWeight: 600 }}>
                              {project.solarRegisterDate}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            margin: "12px 0",
                            background: "#f0f4ff",
                            borderRadius: 6,
                            padding: 8,
                          }}
                        >
                          <ProjectFiles
                            rowData={{
                              id: project.id,
                              fileNumber: project.fileNumber,
                              // add more fields if needed
                            }}
                            mainProps={mainProps}
                          />
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                )
              })}

            </LayersControl>
          </MapContainer>
        </div>
      </Layout>
    </div>
  )
}

export default GasProjectGis
